import { render, staticRenderFns } from "./choose-progress-record.vue?vue&type=template&id=28dde3cb&scoped=true&"
import script from "./choose-progress-record.vue?vue&type=script&lang=js&"
export * from "./choose-progress-record.vue?vue&type=script&lang=js&"
import style0 from "./choose-progress-record.vue?vue&type=style&index=0&id=28dde3cb&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dde3cb",
  null
  
)

export default component.exports